import React from "react";
import { Pagination } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

interface CustomPaginationProps {
  current: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
}

function CustomPagination({
  current,
  total,
  pageSize,
  onChange,
}: CustomPaginationProps) {
  return (
    <div className="custom-pagination">
      <Pagination
        locale={{
          items_per_page: "/ الصفحة",
        }}
        size="small"
        current={current}
        total={total}
        pageSize={pageSize}
        onChange={onChange}
        itemRender={(page, type, originalElement) => {
          if (type === "prev") {
            return <RightOutlined style={{ color: "#0d6e5f" }} />;
          }
          if (type === "next") {
            return <LeftOutlined style={{ color: "#0d6e5f" }} />;
          }
          return originalElement;
        }}
      />
    </div>
  );
}

export default CustomPagination;
